import { useIonModal } from '@ionic/react'

import { UnitTaskQueueFilterModal } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/modals'
import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { commonIcons } from '@apps-common/config/icons'
import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useFilterModalAnimation } from '@apps-common/hooks/useFilterModalAnimation'

export const TasksQueueFilterButton: React.FC = () => {
  const animations = useFilterModalAnimation({ desktopCss: MODAL_NO_BLUR.cssClass })

  const [present, dismiss] = useIonModal(UnitTaskQueueFilterModal, {
    componentProps: {},
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundArrow
      classes='bg-brand'
      iconClasses='text-on-brand'
      Icon={commonIcons.filter}
      callback={() =>
        present({
          cssClass: animations.css,
          ...animations
        })
      }
      tooltip={{
        id: `unit-tasks-queue-filter-tooltip`,
        message: 'Filter'
      }}
    />
  )
}
